import React from "react";
import Text from "../components/atoms/Text";
import Icon from "../components/atoms/Icon";
import Button from "../components/atoms/Button";
import bannerImg from "../assets/bannerimg.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ProductCard from "../components/molecules/ProductCard";
import products from "../data/products";
import Countdown from "../components/atoms/Countdown";
import FeedbackCard from "../components/molecules/FeedbackCard";
import Newsletter from "../components/organisms/Newsletter";

export default function Home() {
  return (
    <>
      <div
        className="homeBanner"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "68px 300px 120px 271px",
          gap: "18px",
          position: "relative",
        }}
      >
        <Icon src={bannerImg} />
        <div
          className="homeBannerText"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text
            size="px14"
            weight="w400"
            color="primary"
            extraStyles={{
              fontFamily: "'Segoe Script', 'Comic Sans MS', cursive",
              textAlign: "start",
            }}
          >
            WELCOME TO SHOPERY
          </Text>
          <Text
            size="px56"
            weight="w600"
            color="greenG9"
            extraStyles={{
              width: "536px",
              textAlign: "start",
              lineHeight: "120%",
            }}
          >
            Fresh & Healthy Organic Food
          </Text>
          <Text
            size="px18"
            weight="w400"
            color="greenG5"
            extraStyles={{
              width: "535px",
              textAlign: "start",
              lineHeight: "150%",
              marginTop: "20px",
              marginBottom: "32px",
            }}
          >
            Free shipping on all your order. we deliver, you enjoy.
          </Text>
          <Button variant="fill" size="large">
            Shop Now{" "}
            <FontAwesomeIcon
              icon={faArrowRight}
              style={{ marginLeft: "16px" }}
            />
          </Button>
        </div>
        <div
          className="facts"
          style={{
            position: "absolute",
            bottom: "-110px",
            left: "271px",
            display: "flex",
          }}
        >
          <div
            className="factItem"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "8px",
              backgroundColor: "var(--primary)",
              width: "250px",
              height: "142px",
              borderRadius: "8px 0px 0px 8px",
              padding: "40px",
            }}
          >
            <div
              style={{
                width: "70px",
                height: "70px",
                border: "1px solid var(--greenG1)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "white",
                marginBottom: "8px",
              }}
            >
              <Icon
                src={require("../assets/Vector.png")}
                size={{ width: "47px", height: "27.7px" }}
              />
            </div>
            <Text size="px18" weight="w600" color="white">
              Free Shipping
            </Text>
            <Text size="px14" weight="w400" color="white">
              Free shipping with discount
            </Text>
          </div>
          <div
            className="factItem"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "8px",
              backgroundColor: "var(--white)",
              width: "250px",
              height: "142px",
              padding: "40px",
              border: "1px solid var(--greenG1)",
              borderLeft: "none",
            }}
          >
            <div
              style={{
                width: "70px",
                height: "70px",
                border: "1px solid var(--greenG1)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "white",
                marginBottom: "8px",
              }}
            >
              <Icon
                src={require("../assets/Vector2.png")}
                size={{ width: "47px", height: "27.7px" }}
              />
            </div>
            <Text size="px18" weight="w600" color="gray9">
              Great Support 24/7
            </Text>
            <Text size="px14" weight="w400" color="gray4">
              Instant access to contact
            </Text>
          </div>
          <div
            className="factItem"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "8px",
              backgroundColor: "var(--white)",
              width: "250px",
              height: "142px",
              padding: "40px",
              border: "1px solid var(--greenG1)",
              borderLeft: "none",
            }}
          >
            <div
              style={{
                width: "70px",
                height: "70px",
                border: "1px solid var(--greenG1)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "white",
                marginBottom: "8px",
              }}
            >
              <Icon
                src={require("../assets/Vector3.png")}
                size={{ width: "47px", height: "27.7px" }}
              />
            </div>
            <Text size="px18" weight="w600" color="gray9">
              100% Secure Payment
            </Text>
            <Text size="px14" weight="w400" color="gray4">
              We ensure your money is safe
            </Text>
          </div>
          <div
            className="factItem"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "8px",
              backgroundColor: "var(--white)",
              width: "250px",
              height: "142px",
              padding: "40px",
              border: "1px solid var(--greenG1)",
              borderRadius: "0px 8px 8px 0px",
              borderLeft: "none",
            }}
          >
            <div
              style={{
                width: "70px",
                height: "70px",
                border: "1px solid var(--greenG1)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "white",
                marginBottom: "8px",
              }}
            >
              <Icon
                src={require("../assets/Vector4.png")}
                size={{ width: "47px", height: "27.7px" }}
              />
            </div>
            <Text size="px18" weight="w600" color="gray9">
              Money-Back Guarantee
            </Text>
            <Text size="px14" weight="w400" color="gray4">
              30-days money-back guarantee
            </Text>
          </div>
        </div>
      </div>
      <div
        className="productSection"
        style={{
          padding: "211px 300px 100px",
          backgroundColor: "var(--greenG05)",
          gap: "24px",
        }}
      >
        <Text size="px40" weight="w600">
          Introducing Our Products
        </Text>
        <Text
          size="px16"
          weight="w400"
          color="gray5"
          onClick={() => (window.location.href = "/shop")}
          extraStyles={{ cursor: "pointer", marginBottom: "26px" }}
          hoverEffect="true"
          hoverColor="primary"
        >
          View All Products
        </Text>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)" }}>
          {products.slice(0, 8).map((product) => (
            <ProductCard key={product.id} product={product} size="large" />
          ))}
        </div>
      </div>
      <div
        className="offers"
        style={{
          padding: "100px 300px",
          display: "flex",
          flexDirection: "row",
          gap: "24px",
        }}
      >
        <div
          className="offer"
          style={{
            backgroundImage: `url(${require("../assets/offer1.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "424px",
            height: "255px",
            display: "flex",
            flexDirection: "column",
            textAlign: "start",
            alignItems: "start",
            justifyContent: "center",
            gap: "12px",
            borderRadius: "8px",
          }}
        >
          <Text
            size="px32"
            weight="w600"
            color="white"
            extraStyles={{ width: "183px", marginLeft: "24px" }}
          >
            100% Fresh Cow Milk
          </Text>
          <Text
            size="px14"
            weight="w400"
            color="white"
            extraStyles={{
              marginLeft: "24px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            Strating at
            <Text size="px20" weight="w500" color="white">
              $14.99
            </Text>
          </Text>
          <Button variant="white" size="medium" style={{ marginLeft: "24px" }}>
            Shop Now
          </Button>
        </div>
        <div
          className="offer"
          style={{
            backgroundImage: `url(${require("../assets/offer2.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "424px",
            height: "255px",
            display: "flex",
            flexDirection: "column",
            textAlign: "start",
            alignItems: "end",
            justifyContent: "center",
            gap: "12px",
            borderRadius: "8px",
          }}
        >
          <Text
            size="px14"
            weight="w500"
            color="greenG9"
            extraStyles={{
              marginRight: "24px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              width: "156px",
              lineHeight: "100%",
            }}
          >
            DRINK SALE
          </Text>
          <Text
            size="px32"
            weight="w600"
            color="greenG9"
            extraStyles={{
              width: "183px",
              marginRight: "24px",
              width: "156px",
              lineHeight: "120%",
            }}
          >
            Water & Soft Drink
          </Text>
          <Button variant="white" size="medium" style={{ marginRight: "47px" }}>
            Shop Now
          </Button>
        </div>
        <div
          className="offer"
          style={{
            backgroundImage: `url(${require("../assets/offer3.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "424px",
            height: "255px",
            display: "flex",
            flexDirection: "column",
            textAlign: "start",
            alignItems: "start",
            justifyContent: "center",
            gap: "12px",
            borderRadius: "8px",
          }}
        >
          <Text
            size="px14"
            weight="w500"
            color="greenG9"
            extraStyles={{
              marginLeft: "24px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              width: "156px",
              lineHeight: "100%",
            }}
          >
            100% ORGANIC
          </Text>
          <Text
            size="px32"
            weight="w600"
            color="greenG9"
            extraStyles={{
              width: "183px",
              marginLeft: "24px",
              width: "156px",
              lineHeight: "120%",
            }}
          >
            Quick Breakfast
          </Text>
          <Button variant="white" size="medium" style={{ marginLeft: "24px" }}>
            Shop Now
          </Button>
        </div>
      </div>
      <div
        className="countdownSection"
        style={{
          padding: "100px 300px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "var(--greenG05)",
          poisiton: "relative",
        }}
      >
        <Text
          size="px16"
          weight="w500"
          color="primary"
          extraStyles={{ marginBottom: "12px" }}
        >
          BEST DEALS
        </Text>
        <Text
          size="px40"
          weight="w600"
          color="greenG9"
          extraStyles={{
            marginBottom: "0px",
            textAlign: "center",
            lineHeight: "120%",
          }}
        >
          Our Special Products
        </Text>
        <Text
          size="px40"
          weight="w600"
          color="greenG9"
          extraStyles={{
            marginBottom: "0px",
            textAlign: "center",
            lineHeight: "120%",
          }}
        >
          Deal Of The Month
        </Text>
        <Countdown targetDate="2026-12-31T23:59:59" />
        <Button variant="fill" size="large" style={{ marginTop: "32px" }}>
          Shop Now
        </Button>
        <Icon
          src={require("../assets/countdownimg1.png")}
          style={{
            width: "521px",
            height: "308px",
            position: "absolute",
            left: "150px",
          }}
        />
        <Icon
          src={require("../assets/countdownimg2.png")}
          style={{
            width: "615px",
            position: "absolute",
            right: "150px",
            marginBottom: "1px",
          }}
        />
      </div>
      <Text
        size="px40"
        weight="w600"
        color="greenG9"
        extraStyles={{ margin: "100px 0px 50px" }}
      >
        Featured Products
      </Text>
      <div
        className="featuredProducts"
        style={{
          display: "flex",
          flexDirection: "row",
          margin: "0px 300px 100px",
        }}
      >
        {products.slice(8, 13).map((product) => (
          <ProductCard key={product.id} product={product} size="medium" />
        ))}
      </div>
      <div
        className="clientFeedback"
        style={{
          padding: "100px 300px 460px",
          gap: "43px",
          backgroundColor: "var(--greenG05)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Text size="px40" weight="w600" color="greenG9">
          What Our Clients Say
        </Text>
        <div
          className="feedbackCards"
          style={{ display: "flex", gap: "24px", flexDirection: "row" }}
        >
          <FeedbackCard
            feedbackText="“Aenean et nisl eget eros consectetur vestibulum vel id erat. Aliquam feugiat massa dui. Sed sagittis diam sit amet ante sodales semper. Aliquam commodo lorem laoreet ultricies ele. ”"
            userIcon={require("../assets/user1.png")}
            userName="Jenny Wilson"
          />
          <FeedbackCard
            feedbackText="“Proin sed neque nec tellus malesuada ultrices eget a justo. Nullam a nibh faucibus, semper risus ac, ultricies est. Maecenas eget purus in enim imperdiet dapibus in ac mi. Fusce faucibus lacus felis”"
            userIcon={require("../assets/user2.png")}
            userName="Guy Hawkins"
          />
          <FeedbackCard
            feedbackText="“Nam sed odio diam. Mauris sagittis sapien sed convallis cursus. Proin mattis ultrices urna ac eleifend. Cras vel nisi nec lectus sagittis venenatis. Curabitur laoreet leo sed lorem pulvina”"
            userIcon={require("../assets/user3.png")}
            userName="Kathryn Murphy"
          />
        </div>
        <div
          className="videoContainer"
          style={{
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            justifyContent: "center",
            alignItems: "center",
            bottom: "-370px",
            backgroundImage: `url(${require("../assets/video.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "1320px",
            height: "740px",
          }}
        >
          <Text
            size="px16"
            weight="w400"
            color="white"
            extraStyles={{
              fontFamily: "'Segoe Script', cursive",
              margin: "0px",
              lineHeight: "100%",
              color: "var(--white)",
            }}
          >
            VIDEO
          </Text>
          <Text
            size="px36"
            weight="w600"
            color="white"
            extraStyles={{
              margin: "0px 0px 20px",
              lineHeight: "120%",
              width: "495px",
            }}
          >
            We’re the Best Organic Farm in the World
          </Text>
          <Icon
            src={require("../assets/Play.png")}
            style={{ width: "80px", height: "80px" }}
          />
        </div>
      </div>
      <div style={{ height: "444px" }}></div>
    </>
  );
}
